import React from 'react';
import OrderButton from './orderButton';
import { OrderType } from '../../../../types/types';
import { orderTypeDisplayName } from '../../../../types/constants';

/**
 * Interface representing the props for the QuestionHeader component.
 *
 * titleText - The title text displayed at the top of the header.
 * qcnt - The number of questions to be displayed in the header.
 * currentOrder - The currently selected order type.
 * setQuestionOrder - A function that sets the order of questions based on the selected message.
 */
interface QuestionHeaderProps {
  titleText: string;
  qcnt: number;
  currentOrder: OrderType;
  setQuestionOrder: (order: OrderType) => void;
}

/**
 * QuestionHeader component displays the header section for a list of questions.
 * It includes the title, the number of the quesions,
 * and buttons to set the order of questions.
 *
 * @param titleText - The title text to display in the header.
 * @param qcnt - The number of questions displayed in the header.
 * @param currentOrder - The currently selected order type.
 * @param setQuestionOrder - Function to set the order of questions based on input message.
 */
const QuestionHeader = ({
  titleText,
  qcnt,
  currentOrder,
  setQuestionOrder,
}: QuestionHeaderProps) => (
  <div className='flex flex-col gap-4 mt-4 sm:flex-row sm:items-center sm:justify-between'>
    <div id='question_count' className='text-muted-foreground'>
      {qcnt} question{qcnt !== 1 ? 's' : ''}
    </div>

    <div className='flex items-center space-x-2'>
      <span className='text-sm text-muted-foreground'>Sort by:</span>
      <div className='flex space-x-1'>
        {Object.keys(orderTypeDisplayName).map(order => (
          <OrderButton
            key={order}
            orderType={order as OrderType}
            currentOrder={currentOrder}
            setQuestionOrder={setQuestionOrder}
          />
        ))}
      </div>
    </div>
  </div>
);

export default QuestionHeader;
